<div slot="header" *ngIf="showMainHeader" fxLayout="column">
    <forge-toolbar class="tyl-card--header-border" [ngClass]="compactMode ? 'compact' : ''" style="display: block;">
        <h1 slot="start" *ngIf="HasTitle() && isPageHeader()"
            [ngClass]="compactMode ? 'forge-typography--heading3' : 'forge-typography--heading4'"
            class="tyl-card--header layout-row layout-align-start-center">
            {{viewTitle}}
        </h1>
        <h2 slot="start" *ngIf="HasTitle() && !isPageHeader()"
            [ngClass]="compactMode ? 'forge-typography--heading3' : 'forge-typography--heading4'"
            class="tyl-card--header layout-row layout-align-start-center">
            {{viewTitle}}
        </h2>
        <div slot="start" *ngIf="showHeaderBadge" class="tt-margin--left layout-row layout-align-start-center">
            <forge-badge *ngFor="let badge of visibleHeaderBadges" [attr.theme]="badge.Theme">{{badge.Text}}
            </forge-badge>
        </div>

        <div slot="end" *ngFor="let customCommand of customViewCommands">
            <forge-icon-button (click)="customCommand.action($event)" [dense]="compactMode">
                <forge-tooltip placement="bottom">{{customCommand.tooltip}}</forge-tooltip>
                <forge-icon [name]="customCommand.icon"></forge-icon>
            </forge-icon-button>
        </div>

        <div slot="end" *ngIf="hasActions" class="layout-row layout-align-end-start">
            <metadata-action-menu [metadataActions]="viewActions" [model]="model" [formData]="datacontroller">
            </metadata-action-menu>
        </div>

        <forge-menu slot="end" *ngIf="showMenu" [options]="menuOptions" (forge-menu-select)="menuItemSelected($event)"
                    placement="bottom" [dense]="compactMode" style="margin-right: 4px;" (forge-menu-open)="menuOpened($event)">
            <forge-icon-button telemetry="Menu-Actions" aria-label="actions menu" [dense]="compactMode">
                <forge-icon name="more_vert"></forge-icon>
            </forge-icon-button>
        </forge-menu>
    </forge-toolbar>
</div>

<!--The content below is only a placeholder and can be replaced.-->
<metadata-attachments *ngIf="IsAttachmentsView" class="layout-fill" [viewTitle]="viewTitle" [view]="view"
                      [datacontroller]="datacontroller" [model]="model" (go-to-form)="goToForm" [path]="path">
</metadata-attachments>

<div *ngIf="(loading || gridLoading) && IsGrid" class="flex layout-row layout-align-center-center">
    <busy-indicator big="true"></busy-indicator>
</div>

<busy-indicator *ngIf="showDialogBusyIndicator" page="true" [dialog]="true"></busy-indicator>

<div *ngIf="!IsAttachmentsView" style="height: 100%;">
    <div class="layout-fill layout-row layout-align-center-start">
        <div *ngIf="IsCombinedView && !IsTabbedView && doneLoadingViews" class="combined-view layout-fill">
            <div *ngFor="let row of rowArray" class="layout-row layout-align-space-evenly-start">
                @for (view of getViewsForRow(row); track view; let i = $index)
                {
                <div class="flex-{{view.DrawWidth}} combined-view--view" style="height: 100%"
                     [ngClass]="viewHasTable(view)">
                    <div ngModelGroup="combinedView{{i}}" class="combined-view--model-group">
                        <forge-card *ngIf="wrapWithCard(view) && !isHidden(view)" class="no-padding">
                            <metadata-view *ngIf="!isHidden(view)" class="layout-column layout-fill"
                                           [viewTitle]="view.Title" [view]="view" [onDelete]="onDeleteBind()"
                                           [datacontroller]="datacontroller" [model]="model" [wrapInForm]="false"
                                           (goToForm)="subGoToForm($event)" [isInView]="isInView" [addMode]="addMode"
                                           [viewOnly]="isViewOnly" [saveableForm]="saveableForm"
                                           [isFocusFirst]="firstRowAndColumn(view) ? isFocusFirst : false"
                                           [customViewCommands]="customViewCommands" [pageHeader]="false"
                                           (modifierCallback)="subCallback($event)" [parentViewId]="parentViewId">
                            </metadata-view>
                        </forge-card>
                        <metadata-view *ngIf="!wrapWithCard(view) && !isHidden(view)" [viewTitle]="view.Title"
                                       [view]="view" [onDelete]="onDeleteBind()" [datacontroller]="datacontroller"
                                       [model]="model" [wrapInForm]="false" [saveableForm]="saveableForm"
                                       (goToForm)="subGoToForm($event)" class="layout-column" [isInView]="isInView"
                                       [addMode]="addMode" [viewOnly]="isViewOnly"
                                       [isFocusFirst]="firstRowAndColumn(view) ? isFocusFirst : false"
                                       [customViewCommands]="customViewCommands"
                                       (modifierCallback)="subCallback($event)" [parentViewId]="parentViewId">
                        </metadata-view>
                    </div>
                </div>
                }
            </div>
        </div>

        <div class="layout-fill" *ngIf="IsTabbedView">
            <div *ngIf="doneLoadingViews" style="height: 100%;">
                <forge-toolbar [ngClass]="compactMode ? 'compact' : ''">
                    <forge-tab-bar slot="before-start" (forge-tab-bar-change)="activateTab($event)" secondary
                                   [ngClass]="{'compact-tab-container': compactMode}" [activeTab]="tabIndex"
                                   layout_mode="clustered" class="view-tab-bar">
                        <forge-tab *ngFor="let view of visibleTabViews; trackBy trackByTitle" [label]="view.Title"
                                   telemetry="Tab-{{view.Title}}" [ngClass]="{'compact-tab': compactMode}">
                            {{view.Title}}
                        </forge-tab>
                    </forge-tab-bar>
                    
                    <forge-menu slot="end" *ngIf="showMenu" [options]="menuOptions" placement="bottom"
                                [dense]="compactMode" (forge-menu-select)="menuItemSelected($event)" 
                                style="pointer-events: auto; margin-right: 4px;" (forge-menu-open)="menuOpened($event)">
                        <forge-icon-button telemetry="Menu-Actions" [dense]="compactMode" aria-label="actions menu">
                            <forge-icon name="more_vert"></forge-icon>
                        </forge-icon-button>
                    </forge-menu>
                    <forge-icon-button slot="end" *ngIf="isCollapsible" aria-label="Collapse header"
                                       (click)="toggleCollapsed()" [dense]="compactMode">
                        <forge-icon [name]="collapseIcon"></forge-icon>
                    </forge-icon-button>
                </forge-toolbar>

                <div [hidden]="!isPanelOpen" class="panel-container" style="pointer-events: auto;">
                    <forge-view-switcher [attr.index]="tabIndex" animation-type="none"
                                         style="height: calc(100% - 49px);">
                        <forge-view *ngFor="let view of visibleTabViews; trackBy trackByTitle" role="tabpanel"
                                    [ngClass]="fillSpaceClassForTabView(view.Views)">
                            <div [ngModelGroup]="view.Title">
                                <metadata-view class="layout-fill tabbed-view" [viewTitle]="view.Title"
                                               [hideTitle]="true" [view]="view" [saveableForm]="saveableForm"
                                               [datacontroller]="datacontroller" [model]="model" [wrapInForm]="false"
                                               [onDelete]="onDeleteBind()" (goToForm)="subGoToForm($event)"
                                               [isInView]="isInView" *ngIf="!isHidden(view)" [addMode]="addMode"
                                               [viewOnly]="isViewOnly"
                                               [isFocusFirst]="firstRowAndColumn(view) ? isFocusFirst : false"
                                               [hideHeaderCheckbox]="hideHeaderCheckbox"
                                               [hideHeaderSelections]="hideHeaderSelections"
                                               (modifierCallback)="subCallback($event)" [parentViewId]="parentViewId">
                                </metadata-view>
                            </div>
                        </forge-view>
                    </forge-view-switcher>
                </div>
            </div>
        </div>
        <div *ngIf="IsCustom && IsSelfContained" class="flex">
            <custom-view *ngIf="initialized" [customDataBinding]="customDataBinding" [component]="view.ControlName"
                         class="flex">
            </custom-view>
        </div>

        <forge-expansion-panel #expansionPanel open [attr.open]="isPanelOpen" (forge-expansion-panel-toggle)="savePanelSetting($event.detail)"
                               *ngIf="(!IsTable || IsMetadataPanelGrid) && !IsCard && !IsCombinedView && !IsSelfContained"
                               class="flex" [ngStyle]="!isCollapsible && {'pointer-events':'none'}"
                               [ngClass]="{'collapsible-panel': isCollapsible}" role="region">
            <forge-toolbar slot="header"
                           style="outline: none; position: relative;" [ngClass]="compactMode ? 'compact' : ''"
                           *ngIf="hasActions || HasTitle() || isCollapsible || hasCollapsibleMenu() || (hasCustomViewCommands && index == 0)">
                <h1 *ngIf="HasTitle() && isPageHeader()" slot="start" [ngClass]="compactMode ? 'forge-typography--heading3' : 'forge-typography--heading4'">
                    {{viewTitle}}
                </h1>

                <h2 *ngIf="HasTitle() && !isPageHeader()" slot="start" [ngClass]="compactMode ? 'forge-typography--heading3' : 'forge-typography--heading4'">
                    {{viewTitle}}
                </h2>

                <div slot="start" *ngIf="showHeaderBadge" class="tt-margin--left layout-row layout-align-start-center">
                    <forge-badge *ngFor="let badge of visibleHeaderBadges" [attr.theme]="badge.Theme">
                        {{badge.Text}}
                    </forge-badge>
                </div>

                <div slot="end" *ngFor="let customCommand of customViewCommands">
                    <forge-icon-button (click)="customCommand.action($event)" [dense]="compactMode">
                        <forge-tooltip placement="bottom">{{customCommand.tooltip}}</forge-tooltip>
                        <forge-icon [name]="customCommand.icon"></forge-icon>
                    </forge-icon-button>
                </div>

                <div slot="end" *ngIf="hasActions" class="layout-row layout-align-end-start"
                     style="pointer-events: auto;">
                    <!-- TODO Add compact functionality to metadata-action-menu -->
                    <metadata-action-menu [metadataActions]="viewActions" [model]="model" [formData]="datacontroller" [expansionPanelAction]="true">
                    </metadata-action-menu>
                </div>

                <forge-menu slot="end" *ngIf="showMenu" [options]="menuOptions" (forge-menu-open)="menuOpened($event)"
                            placement="bottom" [dense]="compactMode" forge-ignore
                            (forge-menu-select)="menuItemSelected($event)" style="pointer-events: auto;">
                    <forge-icon-button telemetry="Menu-Actions" [dense]="compactMode" aria-label="actions menu" (keydown)="menuClicked($event)">
                        <forge-icon name="more_vert"></forge-icon>
                    </forge-icon-button>
                </forge-menu>
                
                <forge-icon-button *ngIf="isCollapsible" slot="after-end" class="tt-margin--right"
                                   aria-label="toggle expansion" [dense]="compactMode">
                    <forge-open-icon [open]="isPanelOpen"></forge-open-icon>
                </forge-icon-button>
            </forge-toolbar>

            <busy-indicator *ngIf="!IsGrid && !IsFooterView && (loading || gridLoading)" card="true">
            </busy-indicator>

            <div class="panel-container metadata-padding" [ngClass]="{'dense-input': view.Dense}"
                 style="pointer-events: auto;">
                <div class="flex layout-fill layout-row layout-align-center-start">
                    <div *ngIf="view.ControlName && !IsSelfContained && !IsGrid">
                        <custom-view *ngIf="initialized" [customDataBinding]="customDataBinding"
                                     [component]="view.ControlName" class="flex"></custom-view>
                    </div>

                    <metadata-panel *ngIf="!view.ControlName && !IsGrid && !loading" class="flex"
                                    [metadata]="view.ViewMetaData" [model]="model" [isMenu]="isMenu"
                                    [focusFirst]="isFocusFirst" [dense]="view.Dense" [datacontroller]="datacontroller"
                                    [viewOnly]="isViewOnly" (modifierCallback)="subCallback($event)"
                                    [ngClass]="{'compact-mode': compactMode}">
                    </metadata-panel>

                    <div *ngIf="IsMetadataPanelGrid" class="layout-fill">
                        <metadata-panel-grid [hidden]="loading" [metadata]="view.GridProperties" [viewOnly]="isViewOnly"
                                             [viewMetadata]="view"
                                             [models]="gridData" (customAdd)="create()" [hasCustomAdd]="true"
                                             [focusFirst]="isFocusFirst" [dense]="view.Dense" [noWrap]="view.NoWrap"
                                             [canAdd]="getAddPermission()" [compact]="IsCompact"
                                             (modifierCallback)="bindGridCallback($event)" (copyAction)="copy($event)"
                                             [datacontroller]="datacontroller"
                                             [ngClass]="{'compact-panel-grid': IsCompact, 'compact-mode': compactMode}"
                                             (allowDeleteCheckFunction)="AllowDeleteCheckBind($event)"
                                             [allowDeleteBindingSet]="true">
                        </metadata-panel-grid>
                        <input [hidden]="loading" type="number" name="minItems" hidden *ngIf="GridMinimum > 0"
                               min="{{GridMinimum}}" [ngModel]="numberOfRowsToShow" telemetry="Edit-minItems">
                    </div>
                </div>
            </div>
        </forge-expansion-panel>

        <div *ngIf="IsCard && !IsCardList && isPanelOpen" class="flex">
            <card-metadata [cardMetadata]="view.Card" [dense]="view.Dense" [viewOnly]="isViewOnly" [model]="model"
                           [datacontroller]="datacontroller" fxFlex="100" class="tt-padding-bottom-sm"></card-metadata>
        </div>

        <div *ngIf="IsTable && !IsMetadataPanelGrid && !IsTree && !IsCardList && isPanelOpen"
             class="view-table--container flex">
            <div *ngIf="ShowMaxRowMessage"
                 class="forge-typography--heading2 tyl-card--header layout-row layout-align-start-center flex-auto">
                {{MaxRowMessage}}
            </div>

            <metadata-table *ngIf="!loading" [hidden]="!!gridLoading" [serverPaging]="serverPaging"
                            [entities]="gridData" [viewMetadata]="view" [gridMetadata]="view.GridProperties"
                            [tableTitle]="viewTitle" [repositoryFunction]="commandFunctionBind()"
                            [preRepositoryFunction]="preCommandFunctionBind()" [disableGridAdd]="disableGridAdd"
                            multipleEdit="true" (modifierCallback)="gridCallbackBind($event)"
                            [disableViewAction]="disableViewAction" [hideHeaderCheckbox]="hideHeaderCheckbox"
                            [hideHeaderSelections]="hideHeaderSelections" [datacontroller]="datacontroller"
                            [parentType]="parentType" [model]="model" [displayHeader]="!showMainHeader && !hideTitle"
                            style="height: 100%; display: flex;" [parentView]="parentViewId"
                            [isStepperGrid]="isStepperView">
            </metadata-table>
            <input type="number" name="minItems" hidden *ngIf="GridMinimum > 0" [min]="GridMinimum"
                   [(ngModel)]="numberOfRowsToShow" telemetry="Edit-GridMin">
        </div>

        <div *ngIf="IsCardList && isPanelOpen && gridData.length > 0" class="view-table--container flex">
            <card-list [view]="view" [entities]="gridData" [datacontroller]="datacontroller"
                       [showHeader]="showMainHeader" [viewTitle]="viewTitle"></card-list>
        </div>

        <div *ngIf="IsTree && hasGridData && isPanelOpen" class="view-table--container flex">
            <metadata-tree [viewMetadata]="view" [entities]="gridData" [datacontroller]="datacontroller" class="flex">
            </metadata-tree>
        </div>

        <div *ngIf="hasErrors" class="metadata-view-buttons">
            <forge-fab mini="true" theme="danger" class="metadata-error--fab" telemetry="Submission-ShowErrors"
                       (click)="showErrors()">
                <forge-icon name="error_outline"></forge-icon>
            </forge-fab>
        </div>
    </div>
    <div flex *ngIf="showIntervalProgress">
        <forge-linear-progress class="tt-margin--bottom"></forge-linear-progress>
    </div>
</div>